export default {
  // 备忘录
  salary: {
    salary: '薪酬',
    payroll: '工资单',
    salaryAccounting: '薪资核算',
    socialSecurityFund: '社保公积金',
    personalIncomeTax: '个税专项附加扣除',
    searchMonth: '搜索月份',
    payrollMonth: '计薪月份',
    payrollPlan: '计薪方案',
    payrollNumber: '计薪人数',
    planName: '方案名称',
    InsuredCity: '参保城市',
    staffJoinNumber: '员工参与人数',
    staffName: '员工姓名',
    mobilePhone: '手机号码',
    department: '部门',
    childrenEducation: '子女教育',
    housingRent: '住房租金',
    rentalloanInterest: '住房贷款利息',
    supportOldman: '赡养老人',
    continuingEducation: '继续教育',
    otherDeductions: '其他扣除',
    seeDetails: '查看详情',
    referenceStaff: '关联员工',
    seePayrollInputPwd: '查看工资详情，请输入密码',
    tipsPwd: '提示：密码为系统登录密码',
    cexiaoDel: '撤销后核算薪资结果将从【工资单】中删除',
    sureCexiao: '确定要撤销已核算薪资吗？',
    fabuSalaryResult: '是否要发布该月核算薪酬结果？',
    fabuSalaryResultInfo: '发布后不可更改且发布到【工资单】，员工可通过工资单查看薪资信息',
    sureDelSalary: '确定要删除核算薪资吗？',
    payrollCycle: '计薪周期',
    unpublished: '未发布',
    approval: '审批中',
    asbeenReleased: '已发布',
    resigned: '已离职',
    fullName: '姓名',
    realWages: '实发工资',
    thisMonthTiaoxin: '本月有调薪',
    wagesType1: '固定工资',
    wagesType2: '浮动工资',
    wagesType3: '津补贴',
    wagesType4: '考勤',
    wagesType5: '代扣代缴',
    wagesType6: '个税累计信息',
    wagesType7: '个税专项附加扣除累计',
    wagesType8: '统计工资',
    sureTongbu: '确定要同步吗？',
    sureTongbuInfo1:
      '确定后，当前薪酬核算将重新获取【薪酬设置】的最新规则，将会对固定工资、浮动工资、津补贴、考勤、代扣代缴和个税进行重新同步，导入数据也将进行清除，现有数据将发生变化。',
    sureTongbuInfo2:
      '确定后，当前薪酬核算将重新获取【考勤】，考勤内容、应发工资和个税进行重新同步且对现有数据将发生改变',
    zancun: '暂存',
    thisMonthLastDay: '本月最后一天',
    salaryHesuanMonth: '薪资核算-月份',
    downloadImportTemplate: '请下载导入模板，根据模板内容完善数据；',
    nameRepeatInputPhone: '若姓名重名，请填写手机号码，否则不能识别。',
    lizhi: '离职',
    tiaoxin: '调薪',
    heji: '合计',
    gonghao: '工号',
    wagesType9: '考勤扣款',
    lastMonth: '截止上月',
    zhiwei: '职位',
    addYuandong: '添加员工',
    sureDelHesuan: '确定要删除核算薪资吗？',
    sureDelThisData: '确定要删除该数据吗？',
    surePushHesuanResult: '是否要发布该月核算薪酬结果？',
    surePushHesuanResultInfo: '发布后不可更改且发布到【工资单】，员工可通过工资单查看薪资信息。',
    sureCexiaoHesuanInfo: '撤消后核算薪资结果将从【工资单】中删除。',
    sureCexiaoHesuan: '确定要撤销已核算薪资吗？',
    dataIsEmpty: '数据有误',
    pleaseAddYuangong: '请添加员工',
    salaryAccounting1: '薪酬核算',
    accountingZhouqi: '核算周期',
    tongbu1: '同步最新薪酬设置',
    tongbu2: '同步考勤结果',
    editJixinPer: '修改计薪人员',
    editMonthValue: '修改上月个税累积值',
    clickContent: '单击数字内容可进行数值修改',
    delYuangong: '删除员工',
    searchUsername: '搜索姓名',
    geshuiInfo:
      '每月应扣除个税专项附加扣除费用，每个员工仅可存在一条数据，用于薪资核算时扣除当月费用。',

    salaryNote: '自动计算机构员工的薪酬，提高财务工作效率。',
    relatedPersonnel: '关联人事模块',
    salarySet: '薪酬设置',
    salaryManager: '薪酬管理员',
    associationType: '关联类型',
    correlationModule: '关联模块',
    addCorrelationModule: '添加更多关联模块，用于固定工资和浮动工资添加项目时所需要的自定义模块',
    inductionDate: '入职日期',
    departureDate: '离职日期',
    salaryAdjustmentDate: '调薪日期',
    salaryAdjustmentRecord: '调薪记录',
    correspondingContent: '项目对应固定工资内容',
    salaryBeforeSalaryAdjustment: '调薪前工资',
    salaryAfterSalaryAdjustment: '调薪后工资',
    associatedNameDate: '关联姓名/日期',
    correspondingTip:
      '定义系统用户与关联模块姓名之间的对应关系；若需要对应计薪周期则需要选择日期，若日期为空则仅直接获取数据第一条；',
    tableName: '据表名称',
    relatedName: '关联姓名',
    relatedData: '关联日期',
    moduleDeleteTip: '确定要删除关联模块吗？',
    correspondingTip2: '确定后请去固定工资和浮动工资中对应调整，否则工资项结果有误。',
    staff: '员工',
    other: '其他',
    staffTble: '员工表',
    resignationApplicationTable: '离职申请表',
    applicationSalaryAdjustmentTable: '调薪申请表',
    dataTable: '数据表',
    schemeAdmin: '方案管理员',
    salaryApproval: '薪酬审批',
    needApproval: '需要审批',
    noNeedApproval: '不需要审批',
    salaryNumber: '薪酬人数',
    modifier: '修改人',
    editTime: '修改时间',
    approvalTip:
      '在薪酬设置审批流程后，提交【薪酬核算】时需走流程审批，审批通过后才发布工资单。若未设置则无须走审批确认后发布。',
    approver: '审批人',
    ruleTip: '可进入后台设置薪酬规则和在前台薪酬模块选取该方案进行每月薪酬核算。',
    approverLength5: '审批人最多5人',
    name: '名称',
    payCycle: '薪资周期',
    correspondingAttendancePeriod: '与考勤周期对应',
    tothisMonth: '至本月',
    scopeOfApplication: '适用范围',
    lastMonthlastDay: '上月最后一天',
    lastDay: '最后一天',
    remark: '备注',
    nextStep: '下一步',
    salaryStructureSetting: '薪酬结构设置',
    attendanceCheck: '考勤计薪',
    jinSubsidy: '津补贴',
    lastMonth2: '上月',
    scopeOfApplication_empty: '适用范围不能为空',
    salaryStructureSettingTip:
      '根据企业的工资表需求，进行薪酬项设计，通过自定义添加满足企业工资计算需要。设置薪酬结构前请确认已设置“关联人事模块”表。',
    wagesTypeTip1: '固定工资计算时区分转正前、转正后与调薪进行分别计算，请先在关联模块中关联调薪',
    wagesTypeTip2: '浮动工资根据个人表现进行薪酬发放',
    wagesTypeTip3:
      '企业给员工提供的福利，请在津补贴中设定福利规则，系统将在核算工资时将补贴加入工资表计算中',
    attendanceCheckTip:
      '根据员工的出勤记录，按一定规则进行工资计算。请在 考勤计薪 中设定规则，若未设定规则考勤内容将不计入工资计算中。',
    salaryDays: '月标准计薪天数计算',
    attendanceScheduling: '考勤排班',
    standardTime: '标准工时',
    personalSocialSecurity: '个人社保',
    providentFund: '公积金',
    monthly: '每月',
    monthly2: '号前离职将不缴纳社保公积金',
    personalTax: '个税',
    accumulatedRevenue: '累计收入额',
    cumulativeDeductionExpense: '累计减除费用',
    accumulatedSpecialDeduction: '累计专项扣除',
    cumulativeSpecialAdditionalDeduction: '累计专项附加扣除',
    cumulativeOtherDeductions: '累计其他扣除',
    cumulativeTaxPayable: '累计应纳税额',
    wageItem: '工资项',
    dataSource: '数据来源',
    keepDecimalPlaces: '保留小数位',
    decimals: '小数位',
    accuracy: '精确度',
    beforeTaxAfterTax: '税前/税后',
    formula: '公式',
    subsidyProject: '津补贴项目',
    inputLength25: '请输入名称，限25字内',
    round: '四舍五入',
    tailRemoval: '去尾法',
    enterOne: '进一法',
    addBeforeTax: '税前加项',
    preTaxDeduction: '税前减项',
    addAfterTax: '税后加项',
    afterTaxDeduction: '税后减项',
    deleteItem: '确定要删除该项吗',
    empty: '不能为空',
    withholdinge_error: '代扣代缴格式错误',
    attendanceAndSalary: '考勤计薪人数',
    numberOfSubsidies: '津补贴人数',
    attendanceCheckHandleTip:
      '用于对企业的请假、加班、旷工的考勤计薪设置规则，可根据企业的情况进行设定。',
    leaveDeductionRules: '请假扣款规则',
    leaveTypeTip: '对应考勤模块中关联审批单的请假类型。',
    eductionRules: '考勤异常扣款规则',
    eductionRulesTip: '考勤状态的缺卡、迟到、旷工、早退扣款规则。',
    missingCardNumber: '缺卡次数',
    late: '迟到',
    eaveEarly: '早退',
    absenteeism: '旷工',
    overlapOrDiscontinuity: '次数不允许出现重叠或间断',
    overtimePayRules: '加班计薪规则',
    overtimeWorkTip: '员工加班，企业给予额外的加班补偿，对应考勤模块中的加班。',
    compensate: '全勤奖和晚班补偿',
    fullAttendance: '全勤奖',
    eveningShift: '晚班',
    calculationItem: '计算项',
    calculationItemTip: '请选择考勤计薪，对应固定工资和浮动工资项税前加项',
    deductionRatio: '扣款比例',
    numberTip: '请输入正数且最多保留2位小数',
    noDeductionDuration: '不扣款时长',
    durationMonth: '时长/每月',
    calculationMethod: '计算方式',
    deductionByTimes: '按次数扣款',
    notRange: '补卡不在统计范围内',
    lateMinuteTip: '每迟到1分钟，扣款',
    lateTimesTip: '每迟到1次，扣款',
    unit: '单位',
    times: '次数',
    personalization: '个性化设置',
    accumulatedLateEveryMonth: '每月累计迟到',
    lateTime: '次内不扣款',
    lateTime2: '次，且单次迟到时长在',
    lateTime3: '次，且累计迟到时长在',
    eaveEarlyMinuteTip: '分钟内不扣款',
    eaveEarlyTimesTip: '每早退1分钟，扣款',
    absenteeismPress: '旷工按',
    doubleSalaryPenalty: '倍工资处罚',
    pleaseEnterNumber: '请输入数字',
    pleaseEnterInteger: '请输入整数',
    fixedAmount: '固定金额',
    yuan: '元',
    compensationProportion: '补偿比例',
    noFullAttendanceAwardWillBeIssued: '满足以下条件之一，不发放全勤奖',
    clockOutTimeExceeds: '下班打卡时间超过',
    nightShiftAward: '晚班奖',
    nightShiftAsChild: '小时计为晚班',
    jinSubsidyTip:
      '按月发放补贴，请在【薪酬结构设置】-津补贴中预设好项目名称，如高温补贴、交通补贴、车补、餐补等，发放方式中按天补贴为实际考勤出勤天数',
    monthlySubsidies: '按月发放补贴',
    subsidyByDay: '按天发放补贴',
    jinSubsidyRules: '津补贴规则',
    deductionRules_error: '津补贴输入框为整数',
    setInsuredBaseAndProportion: '设置参保基数和比例',
    setInsuredAmountOnly: '仅设置参保金额',
    payer: '缴纳人员',
    setInsuredTip: '开启后，“设置参保基数和比例”将被禁用，按该规则来计算社保和公积金',
    associationDataTable: '关联数据表',
    associatedName: '关联姓名',
    companySocialSecurity: '关联机构社保金额',
    personalSocialSecurity2: '关联个人社保金额',
    companyAccumulationFund: '关联机构公积金金额',
    personalAccumulationFund: '关联个人公积金金额',
    paymentCity: '缴纳城市',
    paymentBase: '缴纳基数',
    schemeContent: '方案内容',
    schemeContentTip: '说明：社保公积金会根据省市区获取初始化值，之后有变更需人为维护。',
    socialSecurity: '社保',
    projectName: '项目名称',
    baseLowerLimit: '基数下限',
    baseUpperLimit: '基数上限',
    companyPaymentRatio: '机构缴纳比例',
    individualPaymentRatio: '个人缴纳比例',
    fixedValue: '固定值',
    EndowmentInsurance: '养老保险',
    medicalInsurance: '医疗保险',
    unemploymentInsurance: '失业保险',
    workInjuryInsurance: '工伤保险',
    maternityInsurance: '生育保险',
    definitePreservation: '确定保存',
    nameRepetition: '名称不能重复',
    managerTip: '可进入后台设置薪酬规则和在前台薪酬模块选取方案进行每月薪酬核算。',
    schemeAdminTip: '可进入后台设置社保公积金规则和在前台关联员工。',
    commonOperators: '常用运算符',
    selectFormula: '请选择公式',
    setRule: '设置规则',
    missingCard: '缺卡',
    nightShiftAward_error: '晚班奖格式错误',
    clockOutTime_error: '下班打卡时间只可输入1-8小时',
    fullAttendance_error: '全勤奖格式错误',
    compensationProportion_error: '补偿比例格式错误',
    multiple_error: '倍数格式错误',
    error: '格式错误',
    amountDeduction_error: '扣款金额格式错误',
    pleaseSelectFangan: '请选择计薪方案',
    pleaseSelectYuefen: '请选择计薪月份',
    option1: '按元/次数扣款',
    option2: '按固定金额扣款',
    option3: '按旷工时长扣款',
    option4: '按迟到时长扣款',
    option5: '按迟到次数扣款',
    option6: '按单次迟到时长阶梯扣款',
    option7: '按月累计迟到时长阶梯扣款',
    option8: '按月累计迟到次数阶梯扣款',
    option9: '按早退时长扣款',
    option10: '按单次早退时长阶梯扣款',
    option11: '按月累计早退时长阶梯扣款',
    option12: '按月累计早退次数阶梯扣款',
    option13: '按固定金额补偿',
    option14: '按工资的一定比例补偿',
    option15: '元/次',
    option16: '时长',
    option17: '元/分钟',
    option18: '按早退次数扣款',
    place: '位',
    virtualValue: '请输入有效值',
    deductions: '时长扣款',
    holidaysRequirePay: '节假日需要计薪',
    HD: '小时/天',
    holiday_error: '节假日计薪格式错误',
    noJixinPlan: '当前机构无薪酬方案，请去后台创建方案。',
    // 20201224
    minuteslatesingletime: '单次迟到分钟',
    cumulativeminuteslate: '累计迟到分钟',
    // 20210305
    pageaddmember: '请先在【薪酬管理员】页签中添加人员'
  }
}
